module.exports = __webpack_public_path__ + "img/icon_img02.40173c87.png";